// Administration -> AI Forms (v5/admin/aiforms and v5/admin/aiforms/:id).
// The admin router gives `id` when a form is open.

import React, { useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import { push } from '../../../common/v5/utils';
import { ADMIN } from '../../../common/path';
import { A_AI_FORMS, M_AI_FORMS } from '../../../common/v5/constants';
import { changeAdminView } from '../../../redux/actions/admin';
import AIFormsList from './AIFormsList';
import AIFormEditor from './AIFormEditor';
import { Root } from './ui';

export const aiFormsPath = id => `${ADMIN}/${A_AI_FORMS}` + (id ? "/" + encodeURIComponent(id) : "");

function AIForms({ id, onLoad, onGo }) {
	useEffect(() => { onLoad(); }, [onLoad]);
	const open = useCallback(formId => onGo(aiFormsPath(formId)), [onGo]);
	const back = useCallback(() => onGo(aiFormsPath()), [onGo]);
	return (
		<Root className="aif">
			{id ? <AIFormEditor key={id} formId={id} onBack={back} /> : <AIFormsList onOpen={open} />}
		</Root>
	);
}

const mapDispatchToProps = dispatch => ({
	onLoad: () => dispatch(changeAdminView(M_AI_FORMS)),
	onGo: url => dispatch(push(url)),
});

const AIFormsCtnr = connect(null, mapDispatchToProps)(AIForms);

export default AIFormsCtnr;
